export default async function ({
  store,
  app
}) {
  // const galleries = store.getters['galleries/galleries']
  // if (galleries.length === 0) {
  await store.dispatch('galleries/fetch', {
    params: {
      count: 100500,
      lang: app.i18n.locale
    }
  })
  // }
}
